import { appLogger, addToSessionStorage, getFromSessionStorage } from 'utils'
import { IUserLocation } from 'models'

const getGeolocation = async (
    useProxy?: boolean
): Promise<IUserLocation | null> =>
    fetch(
        useProxy
            ? `/api/location` // TODO: Implement the proxy route
            : `https://pro.ip-api.com/json/?key=${process.env.REACT_APP_IP_API_KEY}`
    )
        .then((res) => res.json() || null)
        .then(async (res: IUserLocation) => {
            if (res && res.countryCode) {
                return res
            }
            if (!res.countryCode && !useProxy) {
                await appLogger({
                    level: 'warn',
                    name: 'getGeolocation()',
                    message:
                        'No countryCode received from API, trying with the proxy'
                })
                return getGeolocation(true)
            }
            return res
        })

export const getCountryCode = async (): Promise<string | null> => {
    // If the location is in sessionStorage, return it
    const sessionLocation = getFromSessionStorage<string>('loc')
    if (sessionLocation) {
        console.debug(
            '[BETSLIP] getCountryCode() from session',
            sessionLocation
        )
        return sessionLocation
    }

    // If the location is not in sessionStorage, get it from API
    let geoLocation
    try {
        geoLocation = await getGeolocation()
    } catch (error) {
        await appLogger({
            level: 'warn',
            name: 'getCountryCode()',
            message: "Can't fetch the nominal API, trying with the proxy"
        })
        geoLocation = await getGeolocation(true)
    }

    // Return the country code
    const countryCode = geoLocation?.countryCode || 'n/a'
    console.debug('[BETSLIP] getCountryCode() from location', countryCode)
    addToSessionStorage('loc', countryCode)
    return countryCode
}
